import { render, staticRenderFns } from "./RooCodeTaskMessage.vue?vue&type=template&id=537b0810&scoped=true"
import script from "./RooCodeTaskMessage.vue?vue&type=script&lang=js"
export * from "./RooCodeTaskMessage.vue?vue&type=script&lang=js"
import style0 from "./RooCodeTaskMessage.vue?vue&type=style&index=0&id=537b0810&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "537b0810",
  null
  
)

export default component.exports